/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_Faq_Q4Inputs */

const en_simple_oto_faq_q4 = /** @type {(inputs: Simple_Oto_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What if it gets stuck?`)
};

const id_simple_oto_faq_q4 = /** @type {(inputs: Simple_Oto_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalau macet di tengah jalan?`)
};

/**
* | output |
* | --- |
* | "What if it gets stuck?" |
*
* @param {Simple_Oto_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_faq_q4 = /** @type {((inputs?: Simple_Oto_Faq_Q4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_Faq_Q4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_faq_q4(inputs)
	return en_simple_oto_faq_q4(inputs)
});